import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useEmployeeBookedShifts = ({ employeeId, branchId }) => {
  const { accountId } = useAccount();

  const storeKey = ['employeeBookedShifts', accountId, employeeId, branchId];

  const { isLoading, data } = useQuery(
    storeKey,
    () => api.fetchEmployeeBookedShifts({ accountId, employeeId, branchId }),
    {
      // Cache key includes employee+branch, so changing either refetches; this only dedupes
      // refetches for the same pair across wizard steps.
      staleTime: 5 * 60 * 1000,
      enabled: !!accountId && !!employeeId && !!branchId
    }
  );

  return {
    isLoading,
    applications: data?.data || []
  };
};

export default useEmployeeBookedShifts;
